export default function BookmarksPage() {
    return <>
    Bookmarks PAGE
    </>;
  }
  